import React, { useEffect } from 'react'
import './Search.css'

const Search = props => {
  useEffect(() => {
    document.onkeydown = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        props.onClose(e)
      }
    }
  })

  return (
    <div
      className="search-overlay active"
      style={{
        visibility: props.open === true ? 'visible' : 'hidden',
        opacity: props.open === true ? 1.0 : 0.0,
      }}
    >
      <SearchCloseIcon onClick={props.onClose} />
      <form
        method="get"
        id="searchform"
        action="https://www.onepointesolutions.com/"
        cr-attached="true"
        _lpchecked="1"
      >
        <input
          onClick={e => console.log(e)}
          type="text"
          name="s"
          id="s"
          placeholder="search"
        />
        <span
          className="search-info"
        >
          Hit Enter to search or ESC to close
        </span>
      </form>
    </div>
  )
}

const SearchCloseIcon = props => {
  return (
    <div
      className="search-btn-close"
      onClick={props.onClick}
    >
      <svg
        className="svg-inline--fa fa-window-close fa-w-16"
        aria-hidden="true"
        data-prefix="fa"
        data-icon="window-close"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        data-fa-i2svg=""
      >
        <path
          fill="currentColor"
          d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
        >
        </path>
      </svg>
    </div>
  )
}

const SearchIcon = props => {
  return (
    <span
      className="search-btn"
      onClick={props.onClick}
    >
      <svg
        className="svg-inline--fa fa-search fa-w-16"
        aria-hidden="true"
        data-prefix="fa"
        data-icon="search"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        data-fa-i2svg=""
      >
        <path
          fill="currentColor"
          d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
        >
        </path>
      </svg>
    </span>
  )
}

export { Search, SearchIcon }
